<template>
    <div class="data-view-item">
        <h1>Stats global {{ entityVerbose }} sur la période {{ startDate }} au {{ endDate }}</h1>
        <ConsumptionTable :entity="entity" :data="consumptionData" table-type="global"></ConsumptionTable>
        <div
            v-if="powerData.length > 0"
        >
            <PowerGraph
                v-for="(item, index) in powerData"
                :key="index"
                :uid="uid"
                :entity="entity"
                :power-data="item"
            ></PowerGraph>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import PowerGraph from './PowerGraph.vue';
import ConsumptionTable from './ConsumptionTable.vue';
    export default {
        name: 'GlobalDataView',
        components: {
            ConsumptionTable,
            PowerGraph
        },
        props:{
            entity:{
                type: String,
                required: true
            },
            consumptionData:{
                type: Array,
                required: true
            },
            uid:{
                type: String,
                required: true
            },
            powerData:{
                type: Array,
                required: true
            },
            startDate:{
                type: String,
                required: false
            },
            endDate:{
                type: String,
                required: false
            },
        },
        computed:{
            entityVerbose(){
                switch (this.entity) {
                    case 'zone':
                        return 'de la zone';
                    case 'machine':
                        return 'de la machine';
                    case 'workshop':
                        return 'de l\'atelier';
                    case 'motor':
                        return 'du moteur';
                    default:
                        return 'du site';
                }
            }
        },
    }
</script>

<style lang="scss" >

</style>


// WEBPACK FOOTER //
// src/components/page/DataView/GlobalDataView.vue